import axios from 'axios';
import CryptoJS from 'crypto-js';

axios.defaults.timeout = 10000;

if (process.env.VUE_APP_NODE_ENV === 'alpha') {
  axios.defaults.baseURL = location.protocol.indexOf('https:') > -1 ? process.env.VUE_APP_HTTPS_BASE_URL : process.env.VUE_APP_HTTP_BASE_URL;
} else {
  axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
}

const chatRoomId = JSON.parse(window.sessionStorage.getItem('CURRENTLY_CHATROOM'))
  ? JSON.parse(window.sessionStorage.getItem('CURRENTLY_CHATROOM')).id
  : 0;

export const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    'x-requested-with': 'XMLHttpRequest',
    'Content-Type': 'application/json'
  },
  timeout: 10000
});

apiClient.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error.response);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// cafe24 open API 용 axios
export const cafe24Request = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    'x-requested-with': 'XMLHttpRequest',
    'Content-Type': 'application/json'
  },
  timeout: 10000
});

function mutateKeyWithTimestamp(secretKey) {
  const timestamp = Math.floor(Date.now() / 1000).toString();
  const secret = secretKey.split('');
  const tRunes = timestamp.split('').map((ch) => parseInt(ch));
  const length = secret.length;

  for (let i = 0; i < tRunes.length - 1; i++) {
    const a = tRunes[i];
    const b = tRunes[i + 1];
    const idx1 = (a * b) % length;
    const idx2 = (b + a + i) % length;

    const tmp = secret[idx1];
    secret[idx1] = secret[idx2];
    secret[idx2] = tmp;
  }

  // 마지막 rotate
  let sum = 0;
  for (const n of tRunes) {
    if (!isNaN(n)) sum += n;
  }
  const rotate = sum % length;
  const rotated = secret.slice(rotate).concat(secret.slice(0, rotate));

  return {
    mutatedKey: rotated.join(''),
    timestamp
  };
}

function isNotAvailable(data) {
  // TODO: 에러코드 팝업 처리는 정책 수립 후 진행
  // switch (data.code) {
  //   case -1000:
  //     window.$mitt.emit('DialogPopup', {
  //       useDialog: true,
  //       message: '<dl class="txt"><dd>잘못된 접근<br />잠시 후 다시 시도해 주세요.</dd></dl>'
  //     });
  //     return;
  //   case -1001:
  //     window.$mitt.emit('DialogPopup', {
  //       useDialog: true,
  //       message: '<dl class="txt"><dd>예상치 않은 문제가 발생했습니다.<br />잠시 후 다시 시도해 주세요.</dd></dl>'
  //     });
  //     return;
  //   case -1002:
  //     window.$mitt.emit('DialogPopup', {
  //       useDialog: true,
  //       message: '<dl class="txt"><dd>데이터 파싱 에러가 발생했습니다.<br />잠시 후 다시 시도해 주세요.</dd></dl>'
  //     });
  //     return;
  //   case -1003:
  //     window.$mitt.emit('DialogPopup', {
  //       useDialog: true,
  //       message: '<dl class="txt"><dd>필수 파라미터 누락으로 검색되지 않습니다.<br/></dd></dl>'
  //     });
  //     return;
  //   case -1004:
  //     window.$mitt.emit('DialogPopup', {
  //       useDialog: true,
  //       message: '<dl class="txt"><dd>통신 에러가 발생했습니다.<br />잠시 후 다시 시도해 주세요.<br/></dd></dl>'
  //     });
  //     return;
  //   case -1005:
  //     window.$mitt.emit('DialogPopup', {
  //       useDialog: true,
  //       message: '<dl class="txt"><dd>현재 사용할 수 없는 상태입니다.<br/>잠시 후 다시 시도해주세요.<br/></dd></dl>'
  //     });
  //     return;
  //   case -2001:
  //     window.$mitt.emit('DialogPopup', {
  //       useDialog: true,
  //       message: '<dl class="txt"><dd>해당 브랜드 정보가 없습니다.<br/></dd></dl>'
  //     });
  //     return;
  //   default:
  //     return false;
  // }
}

cafe24Request.interceptors.request.use(
  (config) => {
    const { mutatedKey, timestamp } = mutateKeyWithTimestamp(process.env.VUE_APP_HMAC_SECRET_KEY);
    // HMAC 시그니처 문자열 구성
    const message = `${timestamp}${chatRoomId}`;
    // HMAC-SHA256 해시 생성
    const signature = CryptoJS.HmacSHA256(message, mutatedKey).toString();

    config.headers['Authorization'] = `${signature}${message}`;
    return config;
  },
  (error) => {
    return Promise.reject(error.response);
  }
);

cafe24Request.interceptors.response.use(
  (response) => {
    if (response.data.code !== 200) {
      isNotAvailable(response.data);
    }
    return response;
  },
  (error) => {
    const data = error.response.data;
    isNotAvailable(data);
    return Promise.reject(error);
  }
);

export default { cafe24Request, apiClient };
